import { AvatarProps } from '@synoptic/ui-kit/avatar/avatar.js';
import { Suspense } from 'react';
import { useAuthInfo } from '@/routes/_app/use-auth-info';
import { useMe } from '@/routes/_app/use-me';
import { S3Avatar } from './s3/user/s3-avatar';

const MyAvatarComponent = (props: Omit<AvatarProps, 'imageSrc' | 'name'>) => {
  const me = useMe();

  return <S3Avatar s3Key={me.avatar?.key} userId={me.id} {...props} />;
};

const MyAvatarFallback = (props: Omit<AvatarProps, 'imageSrc' | 'name'>) => {
  const { id } = useAuthInfo();

  return <S3Avatar s3Key={undefined} userId={id} {...props} />;
};

export const MyAvatar: React.FC<Omit<AvatarProps, 'imageSrc' | 'name'>> = (
  props,
) => {
  return (
    <Suspense fallback={<MyAvatarFallback {...props} />}>
      <MyAvatarComponent {...props} />
    </Suspense>
  );
};
